<template>
  <div id="app">
  
  <router-view  />
  </div>
</template>

<script>


export default {
  name: 'App',
  data(){
    return{     
    }
  },
  methods:{   
  },
  created(){   
     

  }
 
}
</script>

<style>

#app {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
 text-align: center;
 
color: #212529;
 text-decoration: none !important;
}
html,body{
  overflow: hidden;
}
tr, td {
    border: 1px solid #dddddd ;
    text-align: left;
    padding: 8px;
}
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}
</style>
